<nav id="sidebar">
    <ul class="p-0">
        <li class="nav-item class1">
            <span class="spam-text-title">{{'SYSTEM_PROFILES.SYSTEM_PROFILES'|translate}}</span>
            <ul class="class2">
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="admin/my-profile">
                        <span class=" spam-text">{{'SYSTEM_PROFILES.MY_PROFILE'|translate}}</span>
                    </a>
                </li>
                <!-- <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="admin/general-manager">
                        <span class=" spam-text">General Managers</span>
                    </a>
                </li> -->
                <li *ngIf="!isTechSupport" class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="admin/super-administrators">
                        <span class="spam-text">{{'SYSTEM_PROFILES.ADMINISTRATORS'|translate}}</span>
                    </a>
                </li>
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="admin/tech-support">
                        <span class="spam-text">{{'SYSTEM_PROFILES.TECH_SUPPORT'|translate}}</span>
                    </a>
                </li>
            </ul>
        </li>
        <li class="nav-item class1" [class.mb-150px]="inPaymentsMenu">
            <span class="spam-text-title">{{'BUSINESS.BUSINESS'|translate}}</span>
            <ul class="class2">
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="admin/membership-plans">
                        <span class="spam-text">{{'BUSINESS.MEMBERSHIP_PLANS'|translate}}</span>
                    </a>
                </li>
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="admin/payment-processors">
                        <span class="spam-text">{{'BUSINESS.PAYMENT_PROCESSORS'|translate}}</span>
                    </a>
                </li>
                <li class="nav-item nav-item-button" routerLinkActive="active">
<!--                    <a routerLink="admin/payments">-->
<!--                        <span class="spam-text">{{'BUSINESS.PAYMENTS'|translate}}</span>-->
<!--                    </a>-->
                  <p-panelMenu id="subMenu" [transitionOptions]="'0ms'" [model]="paymentsItems" [multiple]="false"></p-panelMenu>
                </li>
            </ul>
        </li>
        <li class="nav-item class1">
            <span class="spam-text-title">{{'MEMBERS.MEMBERS'|translate}}</span>
            <ul class="class2">
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="admin/member-companies">
                        <span class="spam-text">{{'MEMBERS.COMPANIES'|translate}}</span>
                    </a>
                </li>
                <li class="nav-item nav-item-button" routerLinkActive="active">
<!--                    <a routerLink="admin/app-users">-->
<!--                        <span class="spam-text">{{'MEMBERS.APP_USERS'|translate}}</span>-->
<!--                    </a>-->
                  <p-panelMenu id="subMenu" [transitionOptions]="'0ms'" [model]="usersItems" [multiple]="false"></p-panelMenu>
                </li>
            </ul>
        </li>
    </ul>
</nav>
